import Vue from 'vue';
import makingCallDialog from '@/components/makingCall.vue';

const makingCallDialogPlugin = {
  install(Vue) {
    // 创建组件构造器
    const DialogConstructors = Vue.extend(makingCallDialog);
    let instance;

    
    // 初始化单例实例
    function ensureInstance() {
      if (!instance) {
        try {
          instance = new DialogConstructors();
          console.log(instance);
          instance.$mount();
          document.body.appendChild(instance.$el);
        } catch (error) {
          console.error('Failed to create Dialog instance:', error.message);
        }
      }
      return instance;
    }

    // 全局方法：打开弹窗
    function $showMakingCallDialog() {
      const dialogInstance = ensureInstance();
      return dialogInstance.makingCallShow();
    }

    function $hideMakingCallDialog() {
      const dialogInstance = ensureInstance();
      return dialogInstance.makingCallHide();
    }
      function $getCallInfo(callInfoName, callModeText, callModeIcon) {
        const dialogInstance = ensureInstance();
        return dialogInstance.callInfo(callInfoName, callModeText, callModeIcon);
      }
    // 挂载到 Vue 原型
    Vue.prototype.$showMakingCallDialog = $showMakingCallDialog;
    Vue.prototype.$hideMakingCallDialog = $hideMakingCallDialog;
    Vue.prototype.$getCallInfo = $getCallInfo;
  }
};

export default makingCallDialogPlugin;